// extracted by mini-css-extract-plugin
module.exports = {"roundedModal":"FileUploadModal_roundedModal__kYjNt"};